import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { CNASkilledTasksQuestionnaireItem } from './questionnaire'

// CNA Skilled Tasks section questionnaire answer type mapping
export const CNA_SKILLED_TASKS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BATHING_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BATHING_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BRACES_SPLINTS_STOCKINGS_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BRACES_SPLINTS_STOCKINGS_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BRACES_SPLINTS_STOCKINGS_ADDITIONAL]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_DRESSING_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_DRESSING_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_EATING_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_EATING_NOTES]: QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_TUBE_FEEDINGS_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_TUBE_FEEDINGS_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_MEDICATION_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_MEDICATION_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_MOBILITY_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_MOBILITY_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_MOBILITY_ADDITIONAL]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_MEAL_PREP_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_MEAL_PREP_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_GROOMING_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_GROOMING_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_GROOMING_ADDITIONAL]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_SKIN_CARE_APPLICATION_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_SKIN_CARE_APPLICATION_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_SKIN_CARE_APPLICATION_ADDITIONAL]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_SKIN_CARE_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_SKIN_CARE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_SKIN_CARE_ADDITIONAL]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_ROM_EXERCISE_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_ROM_EXERCISE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_RESPIRATORY_CARE_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_RESPIRATORY_CARE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_OXYGEN_THERAPY_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_OXYGEN_THERAPY_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_ORAL_SUCTIONING_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_ORAL_SUCTIONING_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BOWEL_FREQUENCY_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BOWEL_FREQUENCY_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BOWEL_HYGIENE_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BOWEL_HYGIENE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BOWEL_ELIMINATION_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BOWEL_ELIMINATION_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BOWEL_PROGRAM_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_BOWEL_PROGRAM_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_CATHETER_CARE_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_CATHETER_CARE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_MENSES_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_MENSES_NOTES]: QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_URINARY_HYGIENE_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_URINARY_HYGIENE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_POSITIONING_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_POSITIONING_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_TRANSFERS_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_TRANSFERS_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_VITALS_PHYSICIAN_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_VITALS_PHYSICIAN_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_VITALS_NURSE_QUESTION]:
    QuestionnaireAnswerType.CODING,
  [CNASkilledTasksQuestionnaireItem.CNA_SKILLED_TASKS_VITALS_NURSE_NOTES]:
    QuestionnaireAnswerType.STRING
}
